import { generateVuexCrud } from '@/utilities/crud/vuex';

const crud = generateVuexCrud({
    single: 'refreshMessage',
});

const state = {
    ...crud.state,
};

const actions = {
    ...crud.actions,
};

const mutations = {
    ...crud.mutations,
};

export default {
    state,
    actions,
    mutations,
};
